import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';

export const PrivacyWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
          <section className="snn-page-section">
              <h1 className="snn-section-title">Privacy</h1>

              <p>This Privacy Policy describes how the <strong>Symposium of Nanoscience and Nanomaterials
                  2026</strong> handles the information collected through Google Sign-In.</p>

              <h2>1. Information We Collect</h2>
              <p>When you use Google Sign-In, <strong>we do not store or collect any personally identifiable information </strong>
                   beyond what is necessary to authenticate your access to our platform. The only information we have
                  access to through your Google account is what the Google API provides to confirm your identity and
                  grant you access.</p>

              <h2>2. Use of Information</h2>
              <p>The information obtained through Google Sign-In is used <strong>solely and exclusively</strong> for the following
                  purposes:</p>
              <ul>
                  <li><strong>Authentication and Authorization:</strong> To verify your identity and grant you access to
                      our website&apos;s features.
                  </li>
                  <li><strong>Session Management:</strong> To keep your session active while you navigate our site.</li>
              </ul>

              <h2>3. Information Storage and Security</h2>
              <p>We do not store any sensitive information from your Google account on our servers. The authentication
                  information is processed directly through Google&apos;s servers, which are responsible for the security of
                  your data.</p>

              <h2>4. Disclosure of Information</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties.</p>

              <h2>5. Third-Party Links</h2>
              <p>Our website may contain links to third-party sites. We are not responsible for the privacy policies or
                  content of these sites. We recommend reviewing the privacy policies of any third-party websites you
                  visit.</p>

              <h2>6. Your Rights</h2>
              <p>If you have any questions or concerns about our privacy policy, please contact us at nnsymposium@ens.cnyn.unam.mx.</p>

          </section>

      </div>
        <Footer/>
    </>
  );
};
